import React from "react";
import { Modal, Button } from "react-bootstrap";
import Lottie from "react-lottie";

import "./Success_Modal.css";
import successAnimation from "./Success_Modal.json";

const SuccessModal = ({
  show,
  onHide,
  title = "Success!",
  message = "Operation completed successfully.",
  buttonText = "OK",
}) => {
  const animationOptions = {
    loop: false,
    autoplay: true,
    animationData: successAnimation,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      backdrop="static"
      keyboard={false}
      className="success-modal"
    >
      <Modal.Body>
        <div className="success-modal-content">
          <div className="success-lottie">
            <Lottie options={animationOptions} />
          </div>

          <h4>{title}</h4>

          <p>{message}</p>

          {/* <Button type="button" className="success-modal-btn" onClick={onHide}>
            {buttonText}
          </Button> */}
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default SuccessModal;
